export default __webpack_public_path__ + "20c74abf6bdf31b33d57af1f2027d040.svg";